import { HeroForm } from "components/HeroForm";
import { INFO_CHECKMARKS } from "modules/common/consts";
import buttonVaringsConfig from "./HeroForm.config";
import type { HeroFormAdapterProps } from "./HeroForm.d";

const CheckBarAdapter = ({ blok: { buttonText, ctaVariant } }: HeroFormAdapterProps) => <HeroForm buttonText={buttonText} ctaVariant={buttonVaringsConfig[ctaVariant]} checkmarks={INFO_CHECKMARKS} />;

export default CheckBarAdapter;
